import useBinCleanUpDetails from './data-fetch/fetch-binCleanUpData';
import ScaleLoaderItem from '../../../../Ui-Elemnent/ScaleLoader';
import PieChart from './PieChart';

const SocietiesServiced = ({
  city,
  fromDate,
  toDate,
  setTotalTspCount,
  setCleanTspCount
}: {
  city: string;
  fromDate: string;
  toDate: string;
  setTotalTspCount: any;
  setCleanTspCount: any;
}) => {
  const { binCleanUpData, loading } = useBinCleanUpDetails({
    city,
    fromDate,
    toDate,
    setTotalTspCount,
    setCleanTspCount
  });

  // const serviced = binCleanUpData?.servicedCount ?? 0;
  // const total = binCleanUpData?.totalCount ?? 0;
  const serviced = 8;
  const total = 13
  const notServiced = total - serviced;

  return (
    <div style={{ textAlign: "center" }}>
      <h3 className="text-center font-semibold text-blue-900 mb-2">
        Societies serviced ({serviced}/{total})
      </h3>
      {loading ? (
        <ScaleLoaderItem loading={loading} />
      ) : (
        <PieChart serviced={serviced} notServiced={notServiced} />
      )}
    </div>
  );
};

export default SocietiesServiced;


// import LineChart from '../../../Graphs/LineChart'
// import useBinCleanUpDetails from './data-fetch/fetch-binCleanUpData'
// import ScaleLoaderItem from '../../../../Ui-Elemnent/ScaleLoader'
// import SocietyDashboard from './SocietyDashboard'
// const SocietiesServiced = ({city, fromDate, toDate,  setTotalTspCount, setCleanTspCount}:{city:string, fromDate:string, toDate:string, setTotalTspCount:any, setCleanTspCount:any}) => {
//   const option = {
//     maintainAspectRatio: false
//   }
//  const {binCleanUpData, loading} = useBinCleanUpDetails({city:city, fromDate:fromDate, toDate:toDate, setTotalTspCount:setTotalTspCount, setCleanTspCount:setCleanTspCount })
//   return (
//     <div className=''>
    
//     <div>
//     {loading ? <ScaleLoaderItem loading={loading}/> : <LineChart chartData={binCleanUpData} option={option}  /> }
        
//     </div>
//     </div>
//   )
// } 

// export default SocietiesServiced